var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-header"},[_c('h3',[_c('a',{attrs:{"target":"amazon","href":_vm.Url}},[_vm._v(_vm._s(_vm.Name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }